import { render } from "./TagCount.vue?vue&type=template&id=c79fefea&ts=true"
import script from "./TagCount.vue?vue&type=script&lang=ts"
export * from "./TagCount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__